import { classificatorModel } from "../../../services/api/instances/classificatorApi/constants";
import type { ClassPostObjType } from "../../../services/api/instances/classificatorApi/types";

export const CLASSIFICATION_INITIAL_VALUE: ClassPostObjType = {
  prefix: "",
  labels: [],
  text_request: "",
  folder_id: "",
  api_key: "",
  model: classificatorModel,
};
